import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=198444a4&scoped=true&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=198444a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198444a4",
  null
  
)

export default component.exports